import React from "react";
import {
  Row,
  Col,
  Space,
  message,
  Button,
  Modal,
  Image,
  Drawer,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import ListTable from "./ListTable";

import withRouter from "../withRouter";

import { CloseOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

import SpecialOfferStore from "../store/SpecialOfferStore";
import SpecialOfferAdd from "./SpecialOfferAdd";

import editIcon from "../assets/images/NewDesign/pencil-square.svg";

import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";

class SpecialOffer extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.specialOfferStore = new SpecialOfferStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      loadData: 1,
      companyId: "",
      comp_value: "",
      listDataUpdate: false,
      openSpeOfferForm: false,
      deleteData: {},
      openDeleteModal: false,
    };

    this.columns = [
      {
        title: context.translate("_TITLE_"),
        dataIndex: "title",
        width: 20,
        ellipsis: {
          showTitle: true,
        },

        render: (val, record) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.canUpdate("specialOfferList") && this.onEdit(record);
              }}
            >
              {val}
            </Link>
          );
        },
      },
      {
        title: context.translate("_FLEET_DASHBORD_SETTING_DATE_"),
        dataIndex: "createDate",
        width: 11,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_CREATED_BY_"),
        dataIndex: "createdBy",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_FLEET_DASHBORD_NEWPOI_TYPE_"),
        dataIndex: "type",
        width: 10,
        ellipsis: {
          showTitle: true,
        },

        render: (value) => {
          if (value == 3) {
            return <>Special Offer</>;
          }
        },
      },

      {
        title: context.translate("_ACTION_"),
        dataIndex: "action",
        width: 5,
        align: "center",
        ellipsis: {
          showTitle: true,
        },

        render: (_, record) => {
          return (
            <>
              <Space>
                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Tooltip
                    placement="bottom"
                    // title="Delete Record"
                    title={context.translate("_DELETE_RECORD_")}
                    color={config.tooltipColorDelete}
                  >
                    <DeleteFilled style={{ color: config.deleteColor }} />
                  </Tooltip>
                </DeleteConfirm> */}

                {this.props.canUpdate("specialOfferList") && (
                  <Tooltip
                    title={this.context.translate("_EDIT_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>
                )}
                {this.props.canDelete("specialOfferList") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
              </Space>
            </>
          );
        },
      },
    ];

    let columns = this.columns;
    let isadmin = this.props.getUserData().isadmin;
    if (isadmin === 1) {
      columns = this.columns.filter((val) => val.dataIndex !== "action");
    }

    this.columns = columns;
  }
  async componentDidMount() {
    await this.handleSearch();
    this.setState({ pageSize: 50, loadData: 1 });
  }

  onEdit = async (record) => {
    await this.setState({ id: record.id });
    await this.setState({ openSpeOfferForm: true });
  };

  async onDelete(record) {
    const response = await this.specialOfferStore.deleteRecord({
      id: record.id,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.specialOfferStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      page: this.state.currentPage,
    });
    await this.setState({ loadData: 1, loading: false });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  closeModal = () => {
    this.setState({ openSpeOfferForm: false });
  };

  responseMsg = async (resp) => {
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openSpeOfferForm: false });
      await this.handleSearch();
    } else if (resp.success == "F2000") {
      resp.errors.map((value) => {
        message.error(value["error"]);
      });
    }
  };

  refreshList = async () => {
    this.setState({ loading: true });
    await this.specialOfferStore.loadData({
      offset: 0,
      limit: 50,
    });
    this.setState({ loading: false, currentPage: 1 });
  };

  render() {
    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_SPECIAL_OFFER_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  placement="left"
                  //  title="Add"
                  title={this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                  color={config.primaryColor}
                >
                  <Button
                    className="addButton"
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={() =>
                      this.setState({ openSpeOfferForm: true, id: "" })
                    }
                  ></Button>
                </Tooltip>
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}></Col>
            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    cursor: "pointer",
                    marginInlineEnd: "20px",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>
              {this.props.canCreate("specialOfferList") && (
                <Button
                  className="addButtonClass"
                  onClick={() =>
                    this.setState({ openSpeOfferForm: true, id: "" })
                  }
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                </Button>
              )}
            </Col>
          </Row>
          <ListTable
            currentPage={this.state.currentPage}
            total={this.specialOfferStore?.total}
            columns={this.columns}
            pageSize={this.state.pageSize}
            dataSource={this.specialOfferStore?.offerList}
            loading={this.specialOfferStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openSpeOfferForm && (
          // <Modal
          //   bodyStyle={{ height: "645px" }}
          //   className="formShowModal"
          //   title={this.context.translate("_ADD_OFFER_")}
          //   centered
          //   open={this.state.openSpeOfferForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({ openSpeOfferForm: false, id: "" });
          //   }}
          //   width={665}
          // >

          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openSpeOfferForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_ADD_OFFER_")}
                <p className="formDescription">
                  {this.context.translate("_SPECIAL_OFFER_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openSpeOfferForm: false })}
            onCancel={() => this.setState({ openSpeOfferForm: false, id: "" })}
          >
            <div style={{ height: "100%" }}>
              <SpecialOfferAdd
                id={this.state.id}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
SpecialOffer.contextType = StoreContext;
export default observer(withRouter(SpecialOffer));
